import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { getSocialChannelsEnabledForBlog, getPortalHasSocialChannels, getNotificationEmailsEnabled
// @ts-expect-error Untyped module
} from '../redux/selectors/postSettingsSelectors';
import { MultiColumn } from 'foundations-components/transitional/components/MultiColumn';
// @ts-expect-error Untyped module
import PublishingAmpEnabler from 'ContentEditorUI/components/publishing/PublishingAmpEnabler';
// @ts-expect-error Untyped module
import SocialAutoPublishingContainer from '../containers/SocialAutoPublishingContainer';
// @ts-expect-error untyped selectors
import { getEnableGoogleAmpOutput } from '../redux/selectors/ampSelectors';
import { getContentModelContentGroupId, getEnableGoogleAmpOutputOverride
// @ts-expect-error untyped selectors
} from '../redux/selectors/postContentModelSelectors';
// @ts-expect-error untyped selectors
import { getShouldShowSocialAutoPublish } from '../redux/selectors/postSettingsSelectors';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
// @ts-expect-error untyped selectors
import { getCanCustomizeSocial } from '../redux/selectors/postPublishSelectors';
// @ts-expect-error untyped actions
import { updateEnableGoogleAmpOutputOverride } from '../redux/actions/ampActions';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { usePublishModalType } from '../hooks/publishing';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SocialAndAmpSettings = () => {
  const enableGoogleAmpOutput = useSelector(getEnableGoogleAmpOutput);
  const enableGoogleAmpOutputOverride = useSelector(getEnableGoogleAmpOutputOverride);
  const shouldShowSocialAutoPublish = useSelector(getShouldShowSocialAutoPublish);
  const isReadOnlyMode = useSelector(getIsReadOnlyMode);
  const canCustomizeSocial = useSelector(getCanCustomizeSocial);
  const contentGroupId = useSelector(getContentModelContentGroupId);
  const dispatch = useDispatch();
  const handleToggleAmpEnabled = useCallback(() => {
    if (!enableGoogleAmpOutputOverride) {
      UsageTracker.trackEditorInteraction({
        action: 'Settings Action',
        event: 'enabled-amp-post'
      });
    } else {
      UsageTracker.trackEditorInteraction({
        action: 'Settings Action',
        event: 'disabled-amp-post'
      });
    }
    dispatch(updateEnableGoogleAmpOutputOverride(!enableGoogleAmpOutputOverride));
  }, [dispatch, enableGoogleAmpOutputOverride]);
  if (!enableGoogleAmpOutput || shouldShowSocialAutoPublish) {
    return /*#__PURE__*/_jsxs(MultiColumn, {
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(SocialAutoPublishingContainer, {
        canCustomizeSocial: canCustomizeSocial
      }), /*#__PURE__*/_jsx(PublishingAmpEnabler, {
        ampEnabled: enableGoogleAmpOutputOverride,
        contentGroupId: contentGroupId,
        contentType: "blog",
        onToggleAmpEnabled: handleToggleAmpEnabled,
        shouldShow: !enableGoogleAmpOutput,
        disabled: isReadOnlyMode
      })]
    });
  }
  return null;
};
const getEmailNotificationKey = ({
  modalType,
  socialChannelsEnabled,
  portalHasSocialChannels,
  notificationEmailsEnabled
}) => {
  if (!['publish', 'schedule'].includes(modalType)) {
    return '';
  }
  if (socialChannelsEnabled && portalHasSocialChannels) {
    return notificationEmailsEnabled ? 'allNotifications' : 'socialNotificationsOnly';
  } else {
    return notificationEmailsEnabled ? 'emailNotificationsOnly' : 'noNotifications';
  }
};
const EmailNotificationsAlertTitle = styled.span.withConfig({
  displayName: "EmailSocialAmpPublishingOptionsAndInfo__EmailNotificationsAlertTitle",
  componentId: "zyvaed-0"
})(["text-transform:uppercase;"]);
const EmailNotifications = () => {
  const socialChannelsEnabled = useSelector(getSocialChannelsEnabledForBlog);
  const portalHasSocialChannels = useSelector(getPortalHasSocialChannels);
  const notificationEmailsEnabled = useSelector(getNotificationEmailsEnabled);
  const modalType = usePublishModalType();
  if (!notificationEmailsEnabled) {
    return null;
  }
  const emailNotificationKey = getEmailNotificationKey({
    modalType,
    socialChannelsEnabled,
    portalHasSocialChannels,
    notificationEmailsEnabled
  });
  return /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    titleText: /*#__PURE__*/_jsx(EmailNotificationsAlertTitle, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "publishConfirmModal.emailNotifications.title"
      })
    }),
    marginBlockStart: "200",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `publishConfirmModal.emailNotifications.${modalType}${emailNotificationKey ? `.${emailNotificationKey}` : ''}`
    })
  });
};
const EmailSocialAmpPublishingOptionsAndInfo = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EmailNotifications, {}), /*#__PURE__*/_jsx(SocialAndAmpSettings, {})]
  });
};
export default EmailSocialAmpPublishingOptionsAndInfo;